import './LoadingScreen.css'

const VOYABAY_LOGO = 'https://firebasestorage.googleapis.com/v0/b/voyabay-hotels.firebasestorage.app/o/Untitled%20-%202025-12-21T175617.760.png?alt=media&token=51c583f7-5302-40ac-b521-cf142bf6150c'

function LoadingScreen({ message = 'Loading...', fullScreen = true, overlay = false }) {
  const className = fullScreen 
    ? 'loading-screen fullscreen' 
    : overlay 
      ? 'loading-screen overlay'
      : 'loading-screen inline'

  return (
    <div className={className}>
      <div className="loading-content">
        <img src={VOYABAY_LOGO} alt="Voyabay" className="loading-logo" />
        <div className="loading-spinner-ring">
          <div className="spinner-segment"></div>
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  )
}

export default LoadingScreen
